import { Component } from '@theme/component';

/** A persistent pause control for the CSS marquee. */
class EvenmornMarquee extends Component {
  /** @param {MouseEvent} event - Framework-routed pause button. */
  toggle(event) {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('button');
    if (!(button instanceof HTMLButtonElement)) return;
    const paused = this.toggleAttribute('data-paused');
    button.setAttribute('aria-pressed', String(paused));
  }
}

if (!customElements.get('evenmorn-marquee')) customElements.define('evenmorn-marquee', EvenmornMarquee);
